import marketingInstance from '../instance'

const getIsValidFlyerCoupon = (codeId) => {
	return marketingInstance.get(`/flyerCoupons/${codeId}`)
}

export default getIsValidFlyerCoupon
